import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import selectPerson from '@/components/select-person/genera.vue';
// import template from '../../docNotice/doc/template.vue';
import { queryRepairPerson, queryRepairRecord, printRepair, saveSupplement, batchUploadFile } from '@/api/repairs/repairsApi.js';
// import { batchUploadFile } from '@/api/commonApi.js';
var Base64 = require('js-base64').Base64;
export default {
  components: {
    selectPerson: selectPerson
  },
  data: function data() {
    return {
      loadingPrint: false,
      printSrc: '',
      tabList: [{
        title: '组织岗位成员',
        value: 3
      }],
      needHeight: document.documentElement.clientHeight,
      headers: {
        Authorization: sessionStorage.getItem('token')
      },
      evaluationForm: {
        fileList: []
      },
      collectionformRules: {
        selectPersonName: [{
          required: true,
          message: '请选择维修人',
          trigger: ['change', 'blur']
        }],
        status: [{
          required: true,
          message: '请选择维修类别',
          trigger: ['change', 'blur']
        }],
        phone: [{
          required: true,
          message: '请填写手机号',
          trigger: ['change', 'blur']
        }],
        itemNum: [{
          required: true,
          message: '请填写设备编号',
          trigger: ['change', 'blur']
        }],
        itemName: [{
          required: true,
          message: '请填写设备名称',
          trigger: ['change', 'blur']
        }],
        reDate: [{
          required: true,
          message: '请选择故障时间',
          trigger: ['change', 'blur']
        }],
        location: [{
          required: true,
          message: '请填写故障地点',
          trigger: ['change', 'blur']
        }],
        description: [{
          required: true,
          message: '请填写故障描述',
          trigger: ['change', 'blur']
        }],
        itemModel: [{
          required: true,
          message: '请填写设备型号',
          trigger: ['change', 'blur']
        }],
        comUserId: [{
          required: true,
          message: '请选择维修人',
          trigger: ['change', 'blur']
        }],
        repairDate: [{
          required: true,
          message: '请选择维修时间',
          trigger: ['change', 'blur']
        }],
        remark: [{
          required: true,
          message: '请填写反馈内容',
          trigger: ['change', 'blur']
        }]
      },
      collectionform: {
        comType: '维修完成',
        //维修状态
        selectPersonName: '',
        //报修人
        organPostId: {
          userId: '',
          //用户id
          postId: '',
          //岗位id
          organId: '',
          //组织id
          typeId: '' //组织类型
        },
        status: 0,
        //维修类别0现场维修 1厂家维修
        phone: '',
        //手机号
        itemNum: '',
        //设备编号
        itemName: '',
        //设备名称
        reDate: '',
        //故障时间
        location: '',
        //故障地点
        description: '',
        //故障描述
        itemModel: '',
        //设备型号
        comUserId: undefined,
        //维修人
        comUserName: undefined,
        //维修人名字
        repairDate: '',
        //维修时间
        remark: '',
        //维修备注
        supplies: [{
          partName: '',
          //名称
          partModel: '',
          //型号
          partUnit: '',
          //	单位
          partNumber: '',
          //	数量
          partPrice: '',
          //单价
          totalPrice: '',
          //总价
          partFactory: '',
          //厂家
          damageReason: '' //	损坏原因
        }],
        fileList: [],
        faultImgList: []
      },
      formObject: {
        detail: {
          matterList: [{
            startdate: '',
            startplace: '',
            enddate: '',
            endplace: '',
            traffictool: '',
            trafficmoney: '',
            peoplenum: '',
            daynum: '',
            subsidystandard: '',
            subsidymoney: '',
            servefee: '',
            sitefee: '',
            roomboardfee: '',
            insurancefee: '',
            waterfee: '',
            mattertotal: ''
          }]
        }
      },
      options: [],
      // 级联选择数据
      collection: false,
      form: {
        time: [],
        repairsStatus: undefined,
        queryStr: undefined,
        startTime: '',
        endTime: '',
        repairStatus: '',
        type: ''
      },
      expand: false,
      paginationTable: this.$hdk.page(),
      // paginationTable: {
      //     total: 0,
      //     defaultPageSize: 10,
      //     current: 1,
      //     pageSize: 10,
      //     showTotal: total => `共 ${total} 条数据`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '15', '20'],
      //     onShowSizeChange: this.onShowSizeChange,
      //     onChange: this.pageChange
      // },
      tableData: [],
      columns: [{
        title: '报修单号',
        dataIndex: 'number',
        key: 'number',
        width: 15
      }, {
        title: '报修时间',
        dataIndex: 'reDate',
        key: 'reDate',
        width: 15
      }, {
        title: '联系电话',
        dataIndex: 'phone',
        key: 'phone',
        width: 15
      }, {
        title: '使用部门',
        dataIndex: "userDepartment",
        // scopedSlots: { customRender: 'drafterTemp' },
        align: 'center',
        ellipsis: true,
        width: 30
      }, {
        title: '物品名称',
        dataIndex: 'itemName',
        key: 'itemName',
        ellipsis: true,
        width: 20
      }, {
        title: '故障地点',
        dataIndex: 'location',
        key: 'location',
        ellipsis: true,
        width: 15
      }, {
        title: '故障描述',
        dataIndex: 'description',
        key: 'description',
        ellipsis: true,
        width: 30
      }, {
        title: '维修状态',
        dataIndex: 'repairsStatus',
        key: 'repairsStatus',
        scopedSlots: {
          customRender: 'repairsStatus'
        },
        width: 10
      }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        scopedSlots: {
          customRender: 'operation'
        },
        width: 10
      }],
      addRigisterStatus: false,
      addForm: {
        createPerson: undefined
      },
      previewShow: false,
      previewSrc: '',
      viewRigisterStatus: false,
      viewCardBodyStyle: {
        height: '31.25rem'
      },
      loading: false,
      repairPersonList: [] //维修人数组
    };
  },
  methods: {
    /**
    * 展开折叠状态
    */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     * 打印
     */
    printRepairClick: function printRepairClick(row) {
      var _this = this;
      this.loadingPrint = true;
      printRepair(row.id).then(function (res) {
        if (res.data.code == 200) {
          _this.printSrc = res.data.data;
          var frame = document.getElementById('printFrame');
          setTimeout(function () {
            frame.contentWindow.print();
            _this.loadingPrint = false;
          }, 200);
        } else {
          _this.$message.error('未能成功生成文件');
          _this.loadingPrint = false;
        }
      });
    },
    /**
     * 获取维修人员信息
     */
    getQueryRepairPerson: function getQueryRepairPerson() {
      var _this2 = this;
      queryRepairPerson().then(function (res) {
        _this2.repairPersonList = res.data.data;
      });
    },
    /**
     * 文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        collectionform = this.collectionform;
      if (collectionform.fileList.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      } else {
        // 用于上传后回显及往文件对象存值
        this.collectionform.fileList.push({
          fileid: data.file.uid,
          filename: data.file.name,
          fileSize: data.file.size,
          file: data.file,
          uid: data.file.uid,
          name: data.file.name,
          status: 'done',
          type: 0
        });
      }
    },
    /**
     * 文件大小
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 文件删除
     */
    delFile: function delFile(data) {
      var collectionform = this.collectionform;
      if (1 === collectionform.fileList.length) {
        this.collectionform.fileList = [];
        // this.formObject.attach = [];
      } else {
        var evens = _.remove(this.collectionform.fileList, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.collectionform.fileList = evens;
        // this.formObject.attach = evens;
      }
    },
    partPriceChange: function partPriceChange(index) {
      this.collectionform.supplies[index].totalPrice = this.collectionform.supplies[index].partPrice * this.collectionform.supplies[index].partNumber;
    },
    partNumberChange: function partNumberChange(index) {
      this.collectionform.supplies[index].totalPrice = this.collectionform.supplies[index].partPrice * this.collectionform.supplies[index].partNumber;
    },
    personClick: function personClick(e) {
      this.$refs.personPick.handleShow();
    },
    childrenInput: function childrenInput(value) {
      this.collectionform.selectPersonName = value.userData[0].actorName;
      this.collectionform.organPostId.userId = value.userData[0].actorId;
      this.collectionform.organPostId.organId = value.userData[0].organId;
      this.collectionform.organPostId.postId = value.userData[0].postId;
      this.collectionform.organPostId.typeId = value.userData[0].typeId;
    },
    /**
     *提交筛选查询
     */
    search: function search() {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = 10;
      this.getQueryRepairRecord();
      sessionStorage.removeItem('Pagination_infoMgr');
    },
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      sessionStorage.setItem('Pagination_infoMgr', JSON.stringify(pagination));
      this.getQueryRepairRecord({
        current: pagination.current,
        pageSize: pagination.pageSize,
        form: this.form
      });
    },
    /**
     * 查询报修单列表
     */
    getQueryRepairRecord: function getQueryRepairRecord(options) {
      var _this3 = this;
      var paginationTable = this.paginationTable,
        form = this.form,
        pager = _.assign({}, paginationTable, options);
      this.loading = true;
      if (this.form.time.length > 0) {
        this.form.startTime = this.form.time[0];
        this.form.endTime = this.form.time[1];
      } else {
        this.form.startTime = null;
        this.form.endTime = null;
      }
      if (!pager.form) {
        pager.form = form;
      }
      // return;
      queryRepairRecord(pager.current, pager.pageSize, pager.form).then(function (res) {
        _this3.tableData = res.data.data;
        _.assign(paginationTable, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(form, pager.form);
      }).finally(function () {
        _this3.loading = false;
      });
    },
    delMatter: function delMatter(item) {
      var index = this.collectionform.supplies.indexOf(item);
      if (index !== -1) {
        this.collectionform.supplies.splice(index, 1);
      }
    },
    addMatter: function addMatter() {
      this.collectionform.supplies.push({
        partName: '',
        //名称
        partModel: '',
        //型号
        partUnit: '',
        //单位
        partNumber: '',
        //数量
        partPrice: '',
        //单价
        totalPrice: '',
        //总价
        partFactory: '',
        //厂家
        damageReason: '' //	损坏原因
      });
    },
    /**
     * 点击打开补录弹窗
     */
    collectionShow: function collectionShow() {
      this.collection = true;
    },
    saveCollection: function saveCollection() {
      var _this4 = this;
      this.$refs.collectionform.validate(function (vaild) {
        if (vaild) {
          saveSupplement(_this4.collectionform).then(function (res) {
            if (res.data.code == 200) {
              _this4.$message.success('提交成功', 10);
              _this4.collection = false;
              _this4.$refs.collectionform.resetFields();
              _this4.collectionform.repairDate = '';
              _this4.collectionform.comUserId = '';
              _this4.collectionform.fileList = [];
              _this4.collectionform.remark = '';
              _this4.collectionform.supplies = [{
                partName: '',
                //名称
                partModel: '',
                //型号
                partUnit: '',
                //	单位
                partNumber: '',
                //	数量
                partPrice: '',
                //单价
                totalPrice: '',
                //总价
                partFactory: '',
                //厂家
                damageReason: '' //	损坏原因
              }];
              _this4.getQueryRepairRecord();
            } else {
              _this4.$message.error('提交失败', 10);
            }
          });
        } else {
          return;
        }
      });
    },
    collectionSubmit: function collectionSubmit() {
      var _this5 = this;
      if (this.collectionform.status == 1) {
        this.collectionform.repairDate = '';
        this.collectionform.comUserId = '';
        this.collectionform.supplies = [];
      }
      if (this.collectionform.fileList.length > 0) {
        var newFileObj = _.map(this.collectionform.fileList, function (item) {
          if (item.type === 0) {
            return item;
          } else {
            return;
          }
        });
        // 去除为空的
        newFileObj = _.compact(newFileObj);
        // 判断处理后的附件是否为空,为空表示没有新上传附件
        if (newFileObj.length > 0) {
          batchUploadFile(newFileObj).then(function (res) {
            _.map(res.data.data, function (item) {
              _this5.collectionform.faultImgList.push({
                faultImgName: item.originalName,
                faultImgPath: item.filepath,
                originalname: item.originalName
              });
            });
            _this5.saveCollection();
          });
        } else {
          this.saveCollection();
        }
      } else {
        this.saveCollection();
      }
    },
    collectionCancel: function collectionCancel() {
      this.$refs.collectionform.resetFields();
      this.collectionform.repairDate = '';
      this.collectionform.comUserId = '';
      this.collectionform.fileList = [];
      this.collectionform.remark = '';
      this.collectionform.supplies = [{
        partName: '',
        //名称
        partModel: '',
        //型号
        partUnit: '',
        //	单位
        partNumber: '',
        //	数量
        partPrice: '',
        //单价
        totalPrice: '',
        //总价
        partFactory: '',
        //厂家
        damageReason: '' //	损坏原因
      }];
      this.collection = false;
    },
    /**
     * 点击处理跳转至报修详情页面
     */
    disposeClick: function disposeClick(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.id,
          mode: 'accept',
          backTo: 'infoMgr',
          repairsStatus: row.repairsStatus
        }
      });
    },
    onShowSizeChange: function onShowSizeChange(current, pageSize) {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = pageSize;
    },
    pageChange: function pageChange(page, pageSize) {
      this.paginationTable.current = page;
      this.paginationTable.pageSize = pageSize;
    },
    addRigister: function addRigister() {
      this.addRigisterStatus = true;
    },
    addRigisterSubmit: function addRigisterSubmit() {
      this.addRigisterStatus = false;
    },
    addRigisterCancel: function addRigisterCancel() {
      this.addRigisterStatus = false;
      this.$refs.addForm.resetFields();
    },
    handleChangeUpload: function handleChangeUpload(info) {
      if (info.file.status == 'removed') {
        this.$message.success('删除');
        this.addForm.fileList = info.fileList;
        this.previewSrc = '';
        this.previewShow = false;
        return;
      }
      if (!info.file.name.includes('.jpg') && !info.file.name.includes('.png')) {
        this.$message.error('请上传正确格式');
        return;
      }
      this.addForm.fileList = info.fileList;
      if (info.file.response) {
        if (info.file.response.code == 200) {
          this.addForm.fileList = info.fileList;
          this.$message.success('上传成功');
        } else {
          this.$message.error(info.file.response.message);
        }
      }
    },
    handlePreview: function handlePreview(file) {
      var url = file.response.data.url;
      var fileUrl = config.baseUrl + url;
      window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');

      // this.previewShow = true;
      // this.previewSrc =
      //     config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
    },
    handleCancel: function handleCancel() {
      this.previewShow = false;
    },
    viewRigister: function viewRigister(id) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: id,
          mode: 'view',
          backTo: 'infoMgr'
        }
      });
    }
  },
  created: function created() {
    var savedPagination = sessionStorage.getItem('Pagination_infoMgr');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.paginationTable.current = parsed.current || 1;
        this.paginationTable.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.getQueryRepairRecord();
  },
  mounted: function mounted() {
    var savedPagination = sessionStorage.getItem('Pagination_infoMgr');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.getQueryRepairPerson();
  }
};